<a [routerLink]="['/', r.blogs, news().slug]" class="flex h-full min-h-[250px] flex-col gap-2.5 [&.no-image]:items-center [&.no-image]:justify-center [&_img]:max-h-[200px] [&_img]:w-full [&_img]:object-cover [&_img]:object-center"
  [class.no-image]="!news().mainThumb">
  @if (news().mainThumb) {
    <img [alt]="'картинка к записи ' + news().name"
      loading="lazy"
      [src]="imagesPath + '/' + news().mainThumb">
    }
    <div class="p-2.5">{{news().name}}@if (news().link) {
      <app-ext-link-icon/>
    }</div>
  </a>
